module.exports = __webpack_public_path__ + "img/notification-empty.cc0ce170.svg";